export default function Button({ children, ...props }: any) {
    return <button
        type={props?.type || "submit"}
        className="w-4/5 text-lg mt-4 block mx-auto h-10 mb-5 text-white pb-10 pt-4 font-semi-bold bg-blue rounded-lg v-align-middle"
        onClick={props.onClick}
    >
        {children}
    </button>
}